import React, { useEffect, useState } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import API from '../services/api';
import { formatDay } from '../utils/dates';

const money = (n) => new Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' }).format(n || 0);
const dateStr = (d) => formatDay(d, 'Sin compras todavía');

const Stat = ({ label, value, color }) => (
  <Col md={6} className="mb-3">
    <div className="text-muted small">{label}</div>
    <h4 className="mt-1 mb-0" style={color ? { color } : undefined}>{value}</h4>
  </Col>
);

const ClientStatsModal = ({ client, onClose }) => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    API.get(`/clients/${client._id}/stats`)
      .then(res => setStats(res.data))
      .catch(err => {
        console.error('Error loading client stats:', err);
        setError('No se pudieron cargar las estadísticas del cliente.');
      });
  }, [client._id]);

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Historial — {client.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        {!stats && !error && <div className="text-muted">Cargando...</div>}
        {stats && (
          <Row>
            <Stat label="Valor de por vida" value={money(stats.lifetimeValue)} color="var(--mm-cyan)" />
            <Stat label="Cobrado" value={money(stats.amountCollected)} color="var(--mm-green)" />
            <Stat label="Saldo pendiente" value={money(stats.outstandingBalance)} color="var(--mm-yellow)" />
            <Stat label="Facturas" value={stats.invoiceCount} />
            <Stat label="Cotizaciones pendientes" value={stats.pendingQuotesCount} />
            <Stat label="Última compra" value={dateStr(stats.lastPurchaseDate)} />
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ClientStatsModal;
